module.exports = __webpack_public_path__ + "static/media/Used Cat Mining Equipment - Toromont Cat.89ec70ae.jpg";